import { Observable } from "rxjs/Observable";
import { merge } from "rxjs/observable/merge";
import { createActionDuck } from "../helpers/action";
import { createUseAction } from "../helpers/actionHooks";
import { createUseFetch } from "../helpers/fetchHooks";
import createItemFetcher from "../helpers/item";
import { createNotificationsEpic } from "../helpers/notifications";
import { whenConnected } from "../helpers/subscription";
import { StompActionskeys } from "../stomp-broker";
export var updateUndoRedoActions;
(function (updateUndoRedoActions) {
    updateUndoRedoActions["UPDATE_ON_CHANGE"] = "UNDOREDO_SUB/UPDATE_ON_CHANGE";
    updateUndoRedoActions["NOUPDATE_ON_CHANGE"] = "UNDOREDO_SUB/NOUPDATE_ON_CHANGE";
})(updateUndoRedoActions || (updateUndoRedoActions = {}));
export const subscribeToUndoRedoUpdate = (config) => ({
    payload: config,
    type: updateUndoRedoActions.UPDATE_ON_CHANGE,
});
export const unSubscribeToUndoRedoUpdate = () => ({
    type: updateUndoRedoActions.NOUPDATE_ON_CHANGE,
});
export const createSubscriptionEpic = (actions$, _, { stomp }) => {
    return whenConnected(actions$, updateUndoRedoActions.UPDATE_ON_CHANGE).mergeMap(([_value, action]) => {
        return stomp
            .subscribe(`/topic/undoredo/` +
            action.payload.scenario +
            "/" +
            action.payload.workspace)
            .filter((res) => res.type === "UNDOREDO")
            .mergeMap((res) => Observable.of(undoRedoStack.actions.updateItem(action.payload, res.payload)))
            .catch(() => Observable.empty())
            .takeUntil(merge(actions$.ofType(updateUndoRedoActions.NOUPDATE_ON_CHANGE), actions$.ofType(StompActionskeys.DISCONNECTED)));
    });
};
export const computeUndoRedoUrl = (config) => {
    const { scenario, workspace } = config;
    return `/api/v1/undoredo/${scenario}/${workspace}`;
};
const computeItemId = (config) => {
    const { scenario, workspace } = config;
    return `${scenario}_${workspace}`;
};
export const undoRedoStack = createItemFetcher(computeUndoRedoUrl, "UNDOREDO", computeItemId);
undoRedoStack.middleware.push(createSubscriptionEpic);
export const createUndoRedoStack = () => undoRedoStack;
export const useUndoRedoStack = createUseFetch(undoRedoStack, (state) => state.undoRedoStack);
const createaUpdateAfterAction = (action) => (actions$) => actions$
    .ofType(action)
    .mergeMap((action) => Observable.of(undoRedoStack.actions.fetchItem(action.config)));
const computeUndourl = (config) => {
    const url = `/api/v1/undoredo/${config.scenario}/${config.workspace}/undo`;
    return {
        method: "POST",
        url,
    };
};
export const undoAction = createActionDuck("UNDO_ACTION", computeUndourl, computeItemId);
export const createUndoAction = () => undoAction;
const undo_success = undoAction.ActionKeys.FINISH;
const updateAfterUndo = createaUpdateAfterAction(undo_success);
undoAction.middleware = undoAction.middleware.concat(createNotificationsEpic(undoAction.ActionKeys, "undo", (action) => action.id), updateAfterUndo);
export const useUndo = createUseAction(undoAction, (state) => state.undoAction);
const computeRedourl = (config) => {
    const url = `/api/v1/undoredo/${config.scenario}/${config.workspace}/redo`;
    return {
        method: "POST",
        url,
    };
};
export const redoAction = createActionDuck("REDO_ACTION", computeRedourl, computeItemId);
export const createRedoAction = () => redoAction;
export const useRedo = createUseAction(redoAction, (state) => state.redoAction);
const redo_success = redoAction.ActionKeys.FINISH;
const updateAfterRedo = createaUpdateAfterAction(redo_success);
redoAction.middleware = redoAction.middleware.concat(createNotificationsEpic(redoAction.ActionKeys, "redo", (action) => action.id), updateAfterRedo);
//# sourceMappingURL=subscription.js.map